import { render, staticRenderFns } from "./Tabbar.vue?vue&type=template&id=d1947948&scoped=true&"
import script from "./Tabbar.vue?vue&type=script&lang=js&"
export * from "./Tabbar.vue?vue&type=script&lang=js&"
import style0 from "./Tabbar.vue?vue&type=style&index=0&id=d1947948&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1947948",
  null
  
)

export default component.exports